/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkspaceMembersResendResponseItem,
    WorkspaceMembersResendResponseItemFromJSON,
    WorkspaceMembersResendResponseItemFromJSONTyped,
    WorkspaceMembersResendResponseItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspaceMembersResendResponse
 */
export interface WorkspaceMembersResendResponse {
    /**
     * 
     * @type {Array<WorkspaceMembersResendResponseItem>}
     * @memberof WorkspaceMembersResendResponse
     */
    results?: Array<WorkspaceMembersResendResponseItem>;
}

export function WorkspaceMembersResendResponseFromJSON(json: any): WorkspaceMembersResendResponse {
    return WorkspaceMembersResendResponseFromJSONTyped(json, false);
}

export function WorkspaceMembersResendResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMembersResendResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(WorkspaceMembersResendResponseItemFromJSON)),
    };
}

export function WorkspaceMembersResendResponseToJSON(value?: WorkspaceMembersResendResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(WorkspaceMembersResendResponseItemToJSON)),
    };
}


